/**
 * Shore: Labor Day Sale (Sept 1-8, 2026) client-side price mirror.
 *
 * The product page's own scripts (assets/variants.js + assets/product.js)
 * already swap [data-product-price] / [data-compare-price] / [data-save-price]
 * to the real variant.price / variant.compare_at_price whenever a shopper
 * changes variant. Since the Labor Day discount is applied at checkout by
 * the LABOR10 / LABOR20 automatic discounts (not baked into variant.price
 * anymore), this listens for the same 'variant:change' event those scripts
 * already dispatch on document, and - after letting the theme's own price
 * update finish - overwrites the price block with the discounted price for
 * variants covered by the sale, using the exact same variant list as
 * snippets/shore-labor-day-price.liquid and the two automatic discounts.
 *
 * This never changes what's actually charged at checkout (that's the
 * automatic discount's job) - it only keeps the pre-cart display in sync.
 */
(function () {
  'use strict';

  var LD_START = '2026-09-01';
  var LD_END = '2026-09-08';

  var LD_PCT_BY_VARIANT_ID = {
    '41366705668195': 10,
    '43398372360291': 10,
    '41366705635427': 10,
    '41464745492579': 10,
    '43398379634787': 10,
    '41464745459811': 10,
    '41464751685731': 10,
    '41464751718499': 10,
    '42940109422691': 10,
    '42968315068515': 10,
    '42972705521763': 10,
    '42815863128163': 10,
    '43796585939043': 10,
    '43796586430563': 10,
    '43796586463331': 10,
    '44121149833315': 10,
    '44491546427491': 10,
    '42815866962019': 20,
    '42824580661347': 20,
    '42824584593507': 20,
    '42940109455459': 20,
    '42968315101283': 20,
    '42972705554531': 20,
    '42815863160931': 20,
    '44040705245283': 20,
    '44046551777379': 20,
    '44046557282403': 20,
    '44046559969379': 20,
    '44075023138915': 20,
    '44236500238435': 20
  };

  function todayStr() {
    var d = new Date();
    var mm = String(d.getMonth() + 1);
    if (mm.length < 2) mm = '0' + mm;
    var dd = String(d.getDate());
    if (dd.length < 2) dd = '0' + dd;
    return d.getFullYear() + '-' + mm + '-' + dd;
  }

  function laborDaySaleActive() {
    var t = todayStr();
    return t >= LD_START && t <= LD_END;
  }

  function applyOverride(container, variant) {
    if (!variant || !laborDaySaleActive()) return;
    var pct = LD_PCT_BY_VARIANT_ID[String(variant.id)];
    if (!pct) return;
    if (!window.theme || !window.theme.Currency || !window.theme.settings) return;

    var priceEl = container.querySelector('[data-product-price]');
    if (!priceEl) return;
    var compareEl = container.querySelector('[data-compare-price]');
    var wrapEl = container.querySelector('[data-product-price-wrap]');
    var saveEl = container.querySelector('[data-save-price]');
    var a11yEl = container.querySelector('[data-a11y-price]');
    var comparePriceA11yEl = container.querySelector('[data-compare-price-a11y]');

    var regularCents = variant.price;
    var saleCents = Math.round((regularCents * (100 - pct)) / 100);
    var moneyFormat = window.theme.settings.moneyFormat;

    priceEl.innerHTML = window.theme.Currency.formatMoney(saleCents, moneyFormat);
    priceEl.classList.add('on-sale');

    if (compareEl) {
      compareEl.innerHTML = window.theme.Currency.formatMoney(regularCents, moneyFormat);
    }
    if (wrapEl) {
      wrapEl.classList.remove('hide');
    }
    if (a11yEl) {
      a11yEl.setAttribute('aria-hidden', 'false');
    }
    if (comparePriceA11yEl) {
      comparePriceA11yEl.setAttribute('aria-hidden', 'false');
    }
    if (saveEl) {
      var savings = pct + '%';
      if (window.theme.settings.saveType && window.theme.settings.saveType !== 'percent') {
        savings = window.theme.Currency.formatMoney(regularCents - saleCents, moneyFormat);
      }
      if (window.theme.strings && window.theme.strings.savePrice) {
        saveEl.innerHTML = window.theme.strings.savePrice.replace('[saved_amount]', savings);
      }
      saveEl.classList.remove('hide');
    }
  }

  document.addEventListener('variant:change', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    if (!variant) return;
    var container =
      (evt.target && evt.target.closest && evt.target.closest('[data-section-type="product"]')) ||
      document.querySelector('[data-section-type="product"]');
    if (!container) return;

    // Let the theme's own variants.js/product.js price update run first
    // (it's synchronous within the same call stack), then overwrite with
    // the Labor Day sale price on the next tick.
    setTimeout(function () {
      applyOverride(container, variant);
    }, 50);
  });
})();
